import { useContext } from 'react';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../../actions/auth-context';

const DisapproveFinAnalysisButton = ({ order }) => {
  const { hasPermissions, hasRoles } = useContext(AuthContext);

  return (
    <>
      {order.order_status === 'Análise financeira' &&
        (hasPermissions(['financial_analysis']) ||
          hasRoles(['administrator', 'master'])) && (
          <div className="col-6 col-md-3 col-xl-2 mt-2">
            <button
              className="btn btn-danger btn-block col-12"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#modal-financial-disapproved"
            >
              reprovar
            </button>
          </div>
        )}
    </>
  );
};

DisapproveFinAnalysisButton.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string,
    order_status: PropTypes.string,
  }).isRequired,
};

export default DisapproveFinAnalysisButton;
